import './styles.scss'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'

import FormatPrice from '@/components/FormatPrice'
import { useAppSelector } from '@/store/hook'
import {
  selectCartData,
  selectCheckoutSetting,
  selectHasMoqProduct,
} from '@/store/selectors/cartSelector'
import { selectHideVoucher } from '@/store/selectors/configSelector'

const CartSummaryMobile = ({ isLoading = false }) => {
  const { t } = useTranslation()
  const cartData = useAppSelector(selectCartData)
  const shouldHideCartTotalPrice = useAppSelector(selectHasMoqProduct)
  const hideVoucher = useAppSelector(selectHideVoucher)

  const {
    includingVAT: isIncludingVAT,
    headLvlConditions: headLevelConditions,
  } = useAppSelector(selectCheckoutSetting)

  const renderAppliedVoucher = useCallback(() => {
    const { code: voucherCode, totalDiscount } = cartData?.voucherValue ?? {}

    return voucherCode
      ? (
        <div className="full-width-page-component__wrapper cart-summary-mobile__footer">
          <span className="cart-summary-mobile__text cart-summary-mobile__text--large cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase">
            {t('voucher.fields.voucherCode')}
          </span>
          <span
            align="right"
            className="cart-summary-mobile__value cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase cart-summary-mobile__text--large"
          >
            {isLoading ? <Skeleton /> : (
              <FormatPrice
                currencyUnit={cartData?.currencyUnit}
                price={totalDiscount}
              />
            )}
          </span>
        </div>
      )
      : null
  }, [t, isLoading, cartData.voucherValue, cartData.currencyUnit])

  return (
    <div className="cart-summary-mobile__wrapper">
      <div>
        <div>
          <span className="cart-summary-mobile__text cart-summary-mobile__text__sub-total">
            {t('cart.table.subtotal')}
          </span>
          <span
            align="right"
            className="cart-summary-mobile__value cart-summary-mobile__text--medium"
          >
            {isLoading ? <Skeleton /> : !shouldHideCartTotalPrice
              ? (
                <FormatPrice
                  currencyUnit={cartData.currencyUnit}
                  price={cartData.cartSubTotal}
                />
              )
              : null}
          </span>
        </div>
        {!!headLevelConditions && (
          <div>
            <span className="cart-summary-mobile__text">
              {t('cart.table.additionalCost')}
            </span>
            <span align="right" className="cart-summary-mobile__value">
              {isLoading ? <Skeleton /> : (
                <FormatPrice
                  currencyUnit={cartData.currencyUnit}
                  price={cartData.additionalCost}
                />
              )}
            </span>
          </div>
        )}
        <div>
          <span className="cart-summary-mobile__text">
            {t('cart.table.shippingCosts')}
          </span>
          <span align="right" className="cart-summary-mobile__value">
            {isLoading ? <Skeleton /> : (
              <FormatPrice
                currencyUnit={cartData.currencyUnit}
                price={cartData.shippingCosts}
              />
            )}
          </span>
        </div>
        <div className="full-width-page-component__wrapper cart-summary-mobile__footer">
          <span className="cart-summary-mobile__text cart-summary-mobile__text--large cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase">
            {t('total')}
          </span>
          <span
            align="right"
            className="cart-summary-mobile__value cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase cart-summary-mobile__text--large"
          >
            {isLoading ? <Skeleton /> : !shouldHideCartTotalPrice
              ? (
                <FormatPrice
                  currencyUnit={cartData.currencyUnit}
                  price={cartData.cartTotal}
                />
              )
              : null}
          </span>
        </div>

        {!hideVoucher && renderAppliedVoucher()}

        {isIncludingVAT && (
          <>
            <div className="full-width-page-component__wrapper cart-summary-mobile__footer">
              <span className="cart-summary-mobile__text cart-summary-mobile__text--large cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase">
                {t('vat')}
              </span>
              <span
                align="right"
                className="cart-summary-mobile__value cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase cart-summary-mobile__text--large"
              >
                {isLoading ? <Skeleton /> : (
                  <FormatPrice
                    currencyUnit={cartData?.currencyUnit}
                    price={cartData?.vat}
                  />
                )}
              </span>
            </div>
            <div className="full-width-page-component__wrapper cart-summary-mobile__footer">
              <span className="cart-summary-mobile__text cart-summary-mobile__text--large cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase">
                {t('totalWithVat')}
              </span>
              <span
                align="right"
                className="cart-summary-mobile__value cart-summary-mobile__text--bold cart-summary-mobile__text--uppercase cart-summary-mobile__text--large"
              >
                {isLoading ? <Skeleton /> : !shouldHideCartTotalPrice
                  ? (
                    <FormatPrice
                      currencyUnit={cartData?.currencyUnit}
                      price={cartData?.cartTotalVAT}
                    />
                  )
                  : null}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default CartSummaryMobile
